/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-cart',
    'pip-events',
    'window'
],
function installationOptions(
    $,
    Mustache,
    pip,
    pipCart,
    pipEvents,
    window
) {
    var model = {      
        shouldDisplayInstallationOptions: function shouldDisplayInstallationOptions() {
            return !!(pip.installationSku
                && pip.installationSku.doItForMe
                && pip.installationSku.doItForMe.priceIncludes
                && pip.installationSku.doItForMe.priceIncludes.length
                && pip.installationSku.doItYourself
                && ((pip.installationSku.doItYourself.tools && pip.installationSku.doItYourself.tools.length) 
                || (pip.installationSku.doItYourself.materials && pip.installationSku.doItYourself.materials.length)))
        }
    };
        
    var view = {
        selectors: {
            optionsTitleWrapperId: 'attach-labor-options-title-wrapper',
            doItYourselfWrapperId: 'attach-labor-do-it-yourself-wrapper',
            doItForMeWrapperId: 'attach-labor-do-it-for-me-wrapper',
            atcBtn: '#installation-options__atc-btn'
        },
        templates: {
            optionsTitle: window.document.getElementById('attach-labor-options-title') && window.document.getElementById('attach-labor-options-title').innerHTML,
            doItYourself: window.document.getElementById('attach-labor-do-it-yourself') && window.document.getElementById('attach-labor-do-it-yourself').innerHTML,
            doItForMe: window.document.getElementById('attach-labor-do-it-for-me') && window.document.getElementById('attach-labor-do-it-for-me').innerHTML,
        },
        render: {
            optionsTitle: function renderOptionsTitle () {
                return Mustache.render(view.templates.optionsTitle, viewModel);
            },
            doItYourself: function renderDoItYourself() {
                return Mustache.render(view.templates.doItYourself, viewModel);
            },
            doItForMe: function renderDoItForMe() {
                return Mustache.render(view.templates.doItForMe, viewModel);
            }
        },
        elements: {
            installationOptionsWrapper: window.document.getElementById('installation_options'),
        },
        updateDOM: {
            optionsTitle: function updateOptionsTitle() {
                window.document.getElementById(view.selectors.optionsTitleWrapperId).innerHTML = view.render.optionsTitle();
            },
            doItYourself: function updateDoItYourself() {
                window.document.getElementById(view.selectors.doItYourselfWrapperId).innerHTML = view.render.doItYourself();
            },
            doItForMe: function updateDoItForMe() {
                window.document.getElementById(view.selectors.doItForMeWrapperId).innerHTML = view.render.doItForMe();
            },
        },
        showInstallationOptions: function showInstallationOptions () { 
            $(view.elements.installationOptionsWrapper).removeClass('u--hide');
        },
        initEventListeners: function initEventListeners() {
            $(window.document).off('click.installationOptionsATC', view.selectors.atcBtn)
            $(window.document).on('click.installationOptionsATC', view.selectors.atcBtn , function() {
                pipEvents.attachLabor.installationOptionsAtcClicked.trigger()
                pipEvents.attachLabor.attachLaborOptInStateChanged.trigger();
                pipCart.addSthItem(pip.products.primary.data.itemId, pip.customer.quantity);
            });

            pipEvents.attachLabor.newZipCodeProcessed.on('.installationOptions', function(event, homeServicesAddOnAvailability) {
                if(homeServicesAddOnAvailability.isAvailable) {
                    viewModel.init();
                    view.init();  
                }
            })
        },
        init: function init() {
            view.showInstallationOptions();
            view.updateDOM.optionsTitle();
            view.updateDOM.doItYourself();
            view.updateDOM.doItForMe();
            view.initEventListeners();
        }
    };

    var viewModel = {
        diyLists: {
            maxItems: 6,
            limit: function limit(arr) {
                if (!arr) return;
                if(arr.length > this.maxItems) {
                    arr.push({moreItemsText: 'More Items ...'})
                    return arr.slice(0, this.maxItems)
                }
                return arr;
            },
            checkLength: function checkLength(arr) {
                if(!arr) return false;
                return arr.length > viewModel.diyLists.maxItems;
            }
        },
        init: function init() {
            $.extend(true, viewModel, pip.installationSku);

            viewModel.doItYourself.shouldShowMoreToolsText = viewModel.diyLists.checkLength(viewModel.doItYourself.tools)
            viewModel.doItYourself.shouldShowMoreMaterialsText = viewModel.diyLists.checkLength(viewModel.doItYourself.materials)
            viewModel.doItYourself.shouldShowMoreProjectStepsText = viewModel.diyLists.checkLength(viewModel.doItYourself.projectSteps)

            $.extend(viewModel.doItYourself, {
                tools: viewModel.diyLists.limit(viewModel.doItYourself.tools), 
                materials: viewModel.diyLists.limit(viewModel.doItYourself.materials),
                projectSteps: viewModel.diyLists.limit(viewModel.doItYourself.projectSteps)
            });
        }
    }

    return {
        init: function() {
            if(!model.shouldDisplayInstallationOptions()) return;
            
            if(pip.features.attachLaborZipCodeEnabled) {
                viewModel.init();
                view.init();
            }else {
                view.elements.installationOptionsWrapper.className = view.elements.installationOptionsWrapper.className.replace('hide', '');
                $.extend(true, viewModel, pip.installationSku);
    
                viewModel.doItYourself.shouldShowMoreToolsText = viewModel.diyLists.checkLength(viewModel.doItYourself.tools)
                viewModel.doItYourself.shouldShowMoreMaterialsText = viewModel.diyLists.checkLength(viewModel.doItYourself.materials)
                viewModel.doItYourself.shouldShowMoreProjectStepsText = viewModel.diyLists.checkLength(viewModel.doItYourself.projectSteps)
    
                $.extend(viewModel.doItYourself, {
                    tools: viewModel.diyLists.limit(viewModel.doItYourself.tools), 
                    materials: viewModel.diyLists.limit(viewModel.doItYourself.materials),
                    projectSteps: viewModel.diyLists.limit(viewModel.doItYourself.projectSteps)
                });
                window.document.getElementById(view.selectors.optionsTitleWrapperId).innerHTML = Mustache.render(view.templates.optionsTitle, viewModel);
                window.document.getElementById(view.selectors.doItYourselfWrapperId).innerHTML = Mustache.render(view.templates.doItYourself, viewModel);
                window.document.getElementById(view.selectors.doItForMeWrapperId).innerHTML = Mustache.render(view.templates.doItForMe, viewModel);
                view.initEventListeners();
            }
        },
        model: model,
        view: view,
        viewModel: viewModel
    }
})

}.call(window));